import * as actionsTypes from './actionsTypes';

const initialState = {
  surveyTemplateQuestions: [],
  surveyTemplateQuestion: {},
  isLoadingQuestions: false,
  isLoadingQuestion: false,
  isFormSaving: false,
  error: "",
  formError: "",
  surveyTemplateQuestionOptions: {
    options: [],
    combinations: []
  },
  isLoadingQuestionOptions: false,
  errorQuestionOptions: ""
}

export default function surveyTemplateQuestionsReducer(state = initialState, action){
  switch (action.type) {
    case actionsTypes.FETCH_SURVEY_TEMPLATE_QUESTION_REQUEST:
      return {...state, isLoadingQuestion: action.payload}
    case actionsTypes.FETCH_SURVEY_TEMPLATE_QUESTIONS_REQUEST:
      return {...state, isLoadingQuestions: action.payload}
    case actionsTypes.CREATE_SURVEY_TEMPLATE_QUESTION_REQUEST:
      return {...state, isFormSaving: action.payload}
    case actionsTypes.UPDATE_SURVEY_TEMPLATE_QUESTION_REQUEST:
      return {...state, isFormSaving: action.payload}
    case actionsTypes.FETCH_SURVEY_TEMPLATE_QUESTIONS_SUCCESS:
      return {...state, 
                 surveyTemplateQuestions: action.payload, error: "",
                 formError: ""}
    case actionsTypes.FETCH_SURVEY_TEMPLATE_QUESTION_SUCCESS:
      return {...state, surveyTemplateQuestion: action.payload};
    case actionsTypes.FETCH_SURVEY_TEMPLATE_QUESTIONS_FAILURE:
      return { ...state, error: action.payload };
    case actionsTypes.FETCH_SURVEY_TEMPLATE_QUESTION_FAILURE:
      return { ...state, error: action.payload };
    case actionsTypes.CREATE_SURVEY_TEMPLATE_QUESTION_SUCCESS:
      let surveyTemplateQuestions = state.surveyTemplateQuestions;
      surveyTemplateQuestions.push(action.payload);
      surveyTemplateQuestions.sort((a, b) => a.secuence - b.secuence);
      return {...state, surveyTemplateQuestions: surveyTemplateQuestions, formError: ""}
    case actionsTypes.CREATE_SURVEY_TEMPLATE_QUESTION_FAILURE:
      return { ...state, formError: action.payload };
    case actionsTypes.UPDATE_SURVEY_TEMPLATE_QUESTION_SUCCESS:
      return {...state, 
                 surveyTemplateQuestions: state.surveyTemplateQuestions.map(surveyTemplateQuestion => surveyTemplateQuestion.id === action.payload.id ? action.payload : surveyTemplateQuestion), 
                 formError: ""}
    case actionsTypes.UPDATE_SURVEY_TEMPLATE_QUESTION_FAILURE:
      return { ...state, formError: action.payload };
    case actionsTypes.DELETE_SURVEY_TEMPLATE_QUESTION_SUCCESS:
      const stq = state.surveyTemplateQuestions.filter(surveyTemplateQuestion => surveyTemplateQuestion.id !== action.payload);
      return {...state, surveyTemplateQuestions: stq, error: ""}
    case actionsTypes.DELETE_SURVEY_TEMPLATE_QUESTION_FAILURE:
      return { ...state, error: action.payload };
    case actionsTypes.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_REQUEST:
      return {...state, isLoadingQuestionOptions: action.payload}
    case actionsTypes.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_SUCCESS:
      return {...state, surveyTemplateQuestionOptions: action.payload}
    case actionsTypes.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_FAILURE:
      return { ...state, errorQuestionOptions: action.payload };
    case actionsTypes.DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_REQUEST:
      return {...state, isLoadingQuestionOptions: action.payload}
    case actionsTypes.DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_SUCCESS:
      return {...state, surveyTemplateQuestionOptions: action.payload}
    case actionsTypes.DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_FAILURE:
      return { ...state, errorQuestionOptions: action.payload };
    default:
      return state;
  }
}